import { render, staticRenderFns } from "./FormAssignTemplate.vue?vue&type=template&id=9057b2ac&scoped=true&"
import script from "./FormAssignTemplate.vue?vue&type=script&lang=js&"
export * from "./FormAssignTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FormAssignTemplate.vue?vue&type=style&index=0&id=9057b2ac&prod&lang=sass&scoped=true&"
import style1 from "./FormAssignTemplate.vue?vue&type=style&index=1&id=9057b2ac&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9057b2ac",
  null
  
)

export default component.exports